import { useCallback, useMemo, useState } from "react";
import moment from "moment";
import { Box, useMediaQuery } from "@mui/material";
import { DateFilter, ReceiptList } from "../../../../Components/Molecules";
import { mapVoucherStatementsToReceiptItems } from "./voucherStatementAdapter";

export const VoucherExtractSection = ({ categoryLabel, categoryId }) => {
  const matches = useMediaQuery("(min-width: 1220px)");
  const [dateRange, setDateRange] = useState({
    start_date: `${moment().startOf("month").format("YYYY-MM-DD")} 00:00:00`,
    end_date: `${moment().format("YYYY-MM-DD")} 23:59:59`,
  });

  const receiptItems = useMemo(
    () =>
      mapVoucherStatementsToReceiptItems(categoryId, {
        startDate: dateRange.start_date,
        endDate: dateRange.end_date,
      }),
    [categoryId, dateRange]
  );

  const handleFilterSelection = useCallback((value) => {
    setDateRange({
      start_date: value.start_date,
      end_date: value.end_date,
    });
  }, []);

  return (
    <section className="app-card overflow-hidden">
      <div className="cartoes-section-header">
        <div>
          <h3>Extrato · {categoryLabel}</h3>
          <p className="mt-0.5 text-xs font-normal text-gray-500">
            Lançamentos da caixinha selecionada
          </p>
        </div>
      </div>

      <Box
        px={2}
        pt={1.5}
        pb={0.5}
        sx={{ display: "flex", flexDirection: matches ? "row" : "column" }}
      >
        <DateFilter handleFilter={handleFilterSelection} />
      </Box>

      <ReceiptList hasFilter itens={receiptItems} loading={false} type="extract" title="Lançamentos" />
    </section>
  );
};
